var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-dismissible alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("404!")]), _vm._v(" "), _c('h1', [_vm._v("Page not found!")]), _vm._v(" "), _c('router-link', {
    staticClass: "alert-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to Home Page.")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43308da0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 61
// module chunks = 0